import DataTableSkeleton from '@/components/ui/DataTableSkeleton'
import Skeleton from '@/components/ui/Skeleton'

/*
 * Stock Trading before its data: the loaded page block for block, bars only. The filter row
 * (company, From, To, Apply at 40, 44 below `lg`), then the summary card, the count row, ten table
 * rows and the pager's row.
 */

export function StockTradingToolbarSkeleton() {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Skeleton className="h-11 min-w-0 flex-1 basis-full rounded-sm @xl:basis-0 lg:h-10" />
      <Skeleton className="h-11 flex-1 rounded-sm @xl:w-48 @xl:flex-none lg:h-10" />
      <Skeleton className="h-11 flex-1 rounded-sm @xl:w-48 @xl:flex-none lg:h-10" />
      <Skeleton className="h-11 w-18 rounded-sm lg:h-10" />
    </div>
  )
}

export function StockTradingBodySkeleton() {
  return (
    <>
      <div className="mt-2 flex flex-col gap-4 bg-card px-5 py-4">
        <div className="flex items-center gap-3">
          <Skeleton className="size-9 rounded-full" />
          <div className="flex flex-col gap-1">
            <Skeleton className="h-5 w-20 rounded-xs" />
            <Skeleton className="h-4 w-56 rounded-xs" />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-y-4 border-t border-border-subtle pt-4 @xl:grid-cols-4">
          {[0, 1, 2, 3].map((cell) => (
            <div key={cell} className="flex flex-col gap-1">
              <Skeleton className="h-4 w-20 rounded-xs" />
              <Skeleton className="h-6 w-24 rounded-xs" />
            </div>
          ))}
        </div>
      </div>
      <div className="flex h-5 items-center justify-between">
        <Skeleton className="h-4 w-28 rounded-xs" />
        <Skeleton className="h-3 w-20 rounded-xs" />
      </div>
      <div>
        <DataTableSkeleton rows={10} columns={5} />
        <div className="mt-6 h-11 lg:h-8" />
      </div>
    </>
  )
}
